import axios from "axios";
import { getCookie } from "../utils";

const getToken = () => localStorage.getItem("instalimb_token");
const getAchilliToken = () => getCookie("achilli_token");
const getAchilliOffice = () => getCookie("achilli_office");

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_SERVER,
  headers: {
    Authorization: `Bearer ${getToken()}`,
  },
});

axiosInstance.interceptors.request.use(
  function (config) {
    if (getToken()) {
      config.headers = { Authorization: `Bearer ${getToken()}` };
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

const axiosAchilliInstance = axios.create({
  baseURL: process.env.REACT_APP_ACHILLI_SERVER,
  headers: {
    Authorization: `Bearer ${getAchilliToken()}`,
  },
});

axiosAchilliInstance.interceptors.request.use(
  function (config) {
    if (getAchilliToken()) {
      config.headers = {
        ...config.headers,
        Authorization: `Bearer ${getAchilliToken()}`,
        office: getAchilliOffice(),
      };
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

export const http = {
  get: axiosInstance.get,
  post: axiosInstance.post,
  put: axiosInstance.put,
  delete: axiosInstance.delete,
  patch: axiosInstance.patch,
};

export const achilliServer = {
  get: axiosAchilliInstance.get,
  post: axiosAchilliInstance.post,
  put: axiosAchilliInstance.put,
  delete: axiosAchilliInstance.delete,
  patch: axiosAchilliInstance.patch,
};
